import { RecallEventOverlay } from '#app/routes/mocra+/_form+/components/recall-events/overlay.tsx'
import { type RecallEventDraft } from '#app/routes/mocra+/_form+/components/recall-events/types.ts'

type Option = {
	readonly value: string
	readonly label: string
}

type Props = {
	readonly open: boolean
	readonly onOpenChange: (open: boolean) => void
	readonly onSubmit: (draft: RecallEventDraft) => void
	readonly initialValue: RecallEventDraft
	readonly typeOptions: ReadonlyArray<Option>
	readonly outcomeOptions: ReadonlyArray<Option>
	readonly onClosed?: () => void
}

export function RecallEventEditOverlay({
	open,
	onOpenChange,
	onSubmit,
	initialValue,
	typeOptions,
	outcomeOptions,
	onClosed,
}: Props) {
	return (
		<RecallEventOverlay
			mode="edit"
			open={open}
			onOpenChange={onOpenChange}
			onSubmit={onSubmit}
			initialValue={initialValue}
			typeOptions={typeOptions}
			outcomeOptions={outcomeOptions}
			onClosed={onClosed}
		/>
	)
}
